import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { Field, FieldArray, reduxForm } from 'redux-form';
import * as valid from 'utils/validate';
import { api, apiUtils } from 'app/services';
import { invoicesActions, taxesAction } from 'app/actions';
import PropTypes from 'prop-types';
import {
KBInput,
KBRadio,
KBTextarea,
KBSelect,
KBUserInput,
KBDateInput,
KBFormError,
KBButton,
KBPopover } from
'components';
import { DateUtils } from 'utils/dateUtils';
import routerActions from 'app/routerActions';
import { LINE_ITEM_TYPES, POINT_TYPES } from 'app/constants';
import { ADD_ORGANIZATION } from 'app/constants/hint';
import { getEntitiesJsonArray } from 'app/reducers/reducer_utils';
import { toPercent } from 'utils/kbUtil';
import { showApiError } from 'utils/feedback';
import { getTaxes } from 'app/selectors';
import _ from 'lodash';
import dayjs from 'utils/dayjs';
import { renderKBDateInput, renderKBUserInput, toKBField } from 'components/formAdapters/reduxFormAdapters';

const getDefaultInvoiceLine = () => ({
  units: 1,
  unit_price: 0,
  line_item_type: '',
  sales_tax_id: '',
  description: '',
  start_date: dayjs().format('YYYY-MM-DD'),
  end_date: dayjs().format('YYYY-MM-DD')
});

const renderFieldArray = ({ render, ...props }) => render(props);

const renderLineInput = ({ input, meta, type }) => (
  <React.Fragment>
    <input type={type} {...input} />
    {meta.touched && meta.error &&
    <p className="lr-error">
      {' '}
      {meta.error}{' '}
    </p>}
  </React.Fragment>
);

const renderLineSelect = ({ input, meta, ...props }) => (
  <KBSelect field={toKBField(input, meta)} {...props} />
);

const renderLineTextarea = ({ input, meta, ...props }) => (
  <KBTextarea field={toKBField(input, meta)} {...props} />
);

const renderLineDateInput = ({ input, meta, ...props }) => (
  <KBDateInput field={toKBField(input, meta)} {...props} />
);

const renderLineRadio = ({ input, meta, ...props }) => (
  <KBRadio field={toKBField(input, meta)} {...props} name={input.name} />
);

var AddInvoiceForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.createInvoiceForm = this.createInvoiceForm.bind(this);this.goCustom = this.goCustom.bind(this);this.orgInvoices = this.orgInvoices.bind(this);}getInitialState()
  {
    return {
      billType: [] };

  }componentDidMount()
  {
    const { getTaxesAction } = this.props;

    api.getSelfDefinedLineItemTypes().then(
    ({ json }) => {
      let NEW_LINE_ITEM_TYPES = JSON.parse(JSON.stringify(LINE_ITEM_TYPES));
      NEW_LINE_ITEM_TYPES.splice(NEW_LINE_ITEM_TYPES.length - 1, 0, ...json);
      this.setState({
        billType: NEW_LINE_ITEM_TYPES });

    },
    error => {});

    api.getSpaceTaxes().then(
    json => {
      getTaxesAction.success(json);
    },
    error => {
      getTaxesAction.failure(error);
    });

  }createInvoiceForm(

  model) {
    let location_id = this.props.location_id;
    const { contract_id, org, getInvoicesActions } = this.props;
    const { billType } = this.state;

    model.line_items = model.line_items || [];
    for (let i = 0; i < model.line_items.length; i++) {
      for (let j = 0; j < billType.length; j++) {
        if (
        model.line_items[i].line_item_type == billType[j].id &&
        billType[j].charge_code)
        {
          model.line_items[i].line_item_type = 'self_defined';
          model.line_items[i].self_defined_line_item_type_id = billType[j].id;
        }
      }
    }

    if (contract_id) {
      (model.line_items || []).map(item => {
        item.sales_subscription_id = contract_id;
        return item;
      });
    } else if (model.subscription_id) {
      (model.line_items || []).map(item => {
        item.sales_subscription_id = model.subscription_id;
        return item;
      });
    }

    delete model.subscription_id;

    return api.
    postInvoices({
      ...model,
      location_id: location_id || org.locations && org.locations[0] && org.locations[0].id,
      organization_id: org.id }).

    then(json => {
      localStorage.setItem('reloadOrgInvoices', true);
      getInvoicesActions.success(json);
      KBPopover.close();
    }).
    catch(error => {
      showApiError(error);
      return Promise.reject(error);
    });
  }goCustom()

  {
    const { routerActions } = this.props;
    routerActions.replace('/admin/spaces_setting/invoice');
    KBPopover.close();
  }orgInvoices()

  {
    const {
      error,
      submitting,
      handleSubmit,
      taxes } =
    this.props;
    const { billType } = this.state;
    // const newTaxes = taxes.filter(taxe=>taxe.rate===0 || taxe.rate === 0.05 || taxe.rate === 0.06 || taxe.rate === 0.09)
    const newTaxes = [...(taxes || [])].sort((a, b) => a.rate - b.rate);
    return (
      <fieldset className="fieldset">
        <FieldArray name="line_items"
component={renderFieldArray}
rerenderOnEveryChange
render={({ fields }) => {
            return fields.length && billType.length ?
        <ul className="region-input-box">
            {fields &&
          fields.map((name, index) => {
            const line = fields.get(index) || {};
            return (
              <li key={index}>
                    <div className="kb-row">
                      <i
                  className="iconfont icon-close"
                  onClick={() => fields.remove(index)} />

                      <div className="kb-row">
                        <div className="kb-form-group kb-form-alone kb-div-c18">
                          <label style={{ position: 'relative' }}>
                            单价
                            <span
                        style={{
                          color: '#F62D51',
                          position: 'absolute',
                          top: 3,
                          left: '-8px' }}>


                              *
                            </span>
                          </label>
                          <div>
                            <Field name={`${name}.unit_price`} type="text" component={renderLineInput} />
                          </div>
                        </div>
                      </div>
                      <div className="kb-row">
                        <div className="kb-form-group kb-form-alone kb-div-c18">
                          <label
                      style={{ position: 'relative' }}
                      className="label-rt">

                            数量
                            <span
                        style={{
                          color: '#F62D51',
                          position: 'absolute',
                          top: 3,
                          left: '-8px' }}>


                              *
                            </span>
                          </label>
                          <div>
                            <Field name={`${name}.units`} type="number" component={renderLineInput} />
                          </div>
                        </div>
                      </div>
                      <div className="kb-row">
                        <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between' }}>


                          <Field
                      name={`${name}.line_item_type`}
                      component={renderLineSelect}
                      style={{ width: '80%' }}
                      isRequired={true}
                      defaultValue="-1"
                      arrayData={billType}
                      title="类型"
                      className="kb-form-group kb-form-c18 kb-form-alone" />

                          <span
                      style={{
                        width: '15%',
                        height: '34px',
                        marginTop: '30px' }}

                      className="cancel-btn"
                      onClick={this.goCustom}>

                            自定义
                          </span>
                        </div>
                      </div>
                      {line.line_item_type == 'renting_fee' ?
                  <div className="kb-row">
                          <Field
                    name={`${name}.charge_code`}
                    component={renderLineRadio}
                    isRequired={true}
                    className="kb-form-group kb-form-c18 kb-form-alone"
                    rightLabel="label-rt"
                    title="租赁内容"
                    arrayType={POINT_TYPES}
                    inClassName="kb-radio-box"
                    divClassName="kb-form-group kb-div-48"
                    itemStyle={{ width: '80px' }} />

                        </div> :
                  null}
                      <div className="kb-row">
                        <Field
                    name={`${name}.start_date`}
                    component={renderLineDateInput}
                    className="kb-form-group kb-form-c18 kb-form-alone"
                    title="开始日期"
                    isRequired={true}
                    placeholder=""
                    disabledDays={DateUtils.isPastDay} />

                      </div>
                      <div className="kb-row">
                        <Field
                    name={`${name}.end_date`}
                    component={renderLineDateInput}
                    className="kb-form-group kb-form-c18 kb-form-alone"
                    title="结束日期"
                    isRequired={true}
                    placeholder=""
                    disabledDays={DateUtils.isPastDay} />

                      </div>
                      <div className="kb-row">
                        <Field
                    name={`${name}.sales_tax_id`}
                    component={renderLineSelect}
                    defaultValue="-1"
                    arrayData={newTaxes}
                    title="税率"
                    className="kb-form-group kb-form-c18 kb-form-alone"
                    isRequired={true} />

                      </div>
                      <div className="kb-row">
                        <Field
                    name={`${name}.description`}
                    component={renderLineTextarea}
                    title="说明"
                    className="kb-form-group kb-form-c18 kb-form-alone"
                    isRequired={true} />

                      </div>
                    </div>
                  </li>);

          })}
          </ul> :

        '';
          }} />

        <div className="f-left">
          <FieldArray name="line_items"
component={renderFieldArray}
render={({ fields }) => {
              return <button
          className="bordered-btn"
          style={{ marginLeft: 0 }}
          onClick={() => {
            fields.push(getDefaultInvoiceLine());
          }}
          type="button">

            <i className="iconfont icon-add" />
            账款
          </button>;
              }} />
        </div>
      </fieldset>);

  }render()

  {
    const {
      submitting,
      handleSubmit,
      option,
      avaliableSubscriptions,
      contract_id } =
    this.props;

    return (
      <form onSubmit={handleSubmit(this.createInvoiceForm)}>
        <header className="kb-form-header">
          <h2 className="header-title">
            {option == 'generate' ? '单独生成账单' : '归并到下一个账单'}
          </h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <KBFormError error={this.props.error} />
        <div className="kb-form-container">
          <fieldset className="fieldset">
            <div className="kb-row">
              <Field
              name="due_date"
              component={renderKBDateInput}
              className="kb-form-group kb-form-c18 kb-form-alone"
              title="缴费日期"
              isRequired={true}
              placeholder=""
              disabledDays={DateUtils.isPastDay} />

            </div>
            {option == 'generate' && !contract_id ?
            <div className="kb-row">
                <Field
              name="subscription_id"
              component={renderKBUserInput}
              title="选择合同"
              placeholder="选择账款需要关联的合同"
              className="kb-form-group kb-form-c18 kb-form-alone"
              selectedUsers={[]}
              multi={false}
              users={avaliableSubscriptions} />

              </div> :
            null}
            {this.orgInvoices()}
          </fieldset>
          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              确定
            </KBButton>
          </div>
        </div>
      </form>);

  }};


AddInvoiceForm.propTypes = {
  location_id: PropTypes.number.isRequired,
  org: PropTypes.object.isRequired };


function mapStateToProps(state, props) {
  const { org } = props;
  let taxes = Object.assign([], getTaxes(state));
  taxes = _.cloneDeep(taxes).map(tax => {
    let name = tax.name;
    tax.name = `${name} (税率:${toPercent(tax.rate, 2)})`;
    return tax;
  });
  const avaliableSubscriptions =
  org &&
  org.sales_subscriptions &&
  org.sales_subscriptions.
  filter((sub) =>
  ['ended', 'draft', 'active', 'expiring'].includes(sub.status)).

  map(sub => {
    sub.name = sub.serial;
    return sub;
  }) ||
  [];

  return {
    taxes,
    avaliableSubscriptions };

}

function mapDispatchToProps(dispatch) {
  return {
    getInvoicesActions: bindActionCreators(invoicesActions.get, dispatch),
    getTaxesAction: bindActionCreators(taxesAction.get, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch) };

}

const validateLine = line => {
  const errors = {};
  if (valid.isNumber(line.unit_price)) {
    errors.unit_price = '请输入正确的价格, 小数点保留2位';
  }

  if (valid.required(line.units) || line.units == 0) {
    errors.units = '请输入数量并且不等于0';
  }

  if (valid.required(line.line_item_type)) {
    errors.line_item_type = '请选择类型';
  }

  if (!line.charge_code && line.line_item_type == 'renting_fee') {
    errors.charge_code = '请选择租赁内容';
  }

  if (!line.start_date && line.line_item_type == 'renting_fee') {
    errors.start_date = '请选择开始时间';
  }

  if (!line.end_date && line.line_item_type == 'renting_fee') {
    errors.end_date = '请选择结束时间';
  }

  if (line.start_date && line.end_date && !dayjs(line.start_date).isSameOrBefore(line.end_date)) {
    errors.end_date = '请选择晚于或者等于开始时间的结束时间';
  }


  if (!line.sales_tax_id || line.sales_tax_id == -1) {
    errors.sales_tax_id = '请选择税率';
  }

  if (!line.description) {
    errors.description = '请输入说明';
  }

  return errors;
};

const validate = values => {
  const errors = {};

  if (valid.required(values.due_date)) {
    errors.due_date = '请选择缴费日期';
  }

  errors.line_items = (values.line_items || []).map(validateLine);

  return errors;
};

const formConfig = {
  form: 'AddInvoiceForm',
  validate: validate,
  touchOnBlur: false };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(AddInvoiceForm));
